export enum ENDPOINTS {
  VENUES = '/venues',
  LISTINGS = '/listings',
  BOOKINGS = '/bookings',
  DASHBOARD = '/dashboard',
  COACHES = '/coaches',
  IMAGES = '/images'
}
